import React from 'react';
import styled from 'styled-components';
import Color from '../../../utils/colors';
import { Font, FontWeight } from '../../../utils/fonts';
import typograf from '../../../utils/typograf';

import dataPhases from '../consts/dataPhases';
import mediaWidth, { Width } from '../../../utils/mediaWidth/mediaWidth';

import ArrowBlueIcn from '../assets/arrow-blue.svg';
import ArrowWhiteIcn from '../assets/arrow-white.svg';

class Start extends React.PureComponent {
    render() {
        const { showCurrentPhase } = this.props;
        return (
            <Container>
                <Title>{typograf.execute('На каком этапе создания продукта вы\nнаходитесь?')}</Title>
                <SubTitle>{typograf.execute('Расскажите и узнайте больше о каждом этапе, а мы поможем вам двигаться дальше')}</SubTitle>
                <CardsWrapper>
                    {dataPhases.map((phase, index) => (
                        <Card key={index.toString()} onClick={() => showCurrentPhase(index)}>
                            <div>
                                <CardTitle>{typograf.execute(phase.name)}</CardTitle>
                                <CardDescription>
                                    {typograf.execute(phase.description)}
                                </CardDescription>
                            </div>
                            <CardBottom>
                                <CardDigit>0{index + 1}</CardDigit>
                                <CardArrow />
                            </CardBottom>
                        </Card>
                    ))}
                </CardsWrapper>
            </Container>
        );
    }
}

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 136px 16px 16px;

  ${Font.PRIMARY};
  ${FontWeight.REGULAR};
  
  ${mediaWidth.m} {
    width: ${Width.M}px;
    padding: 176px 48px 60px;
  }
  
  ${mediaWidth.l} {
    width: ${Width.L}px;
    padding: 176px 64px 56px;
  }
  
  ${mediaWidth.xl} {
    width: ${Width.XL}px;
    padding: 228px 59px 134px 60px;
  }
`;

const Title = styled.div`
  color: ${Color.TEXT_PRIMARY};
  
  ${Font.HEADLINE};
  font-size: 32px;
  line-height: 32px;
  text-transform: uppercase;
  
  ${mediaWidth.m} {
    font-size: 56px;
    line-height: 56px;
  }
  
  ${mediaWidth.l} {
    width: 743px;
  }
  
  ${mediaWidth.xl} {
    width: 952px;
    font-size: 64px;
    line-height: 64px;
  }
`;

const SubTitle = styled.div`
  margin-top: 44px;
  
  color: ${Color.TEXT_PRIMARY};
  opacity: .64;
  font-size: 16px;
  line-height: 24px;

  ${mediaWidth.m} {
    margin-top: 32px;
    width: 550px;
    font-size: 20px;
    line-height: 28px;
  }

  ${mediaWidth.xl} {
    font-size: 24px;
    line-height: 32px;
  }
`;

const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  ${mediaWidth.m} {
    margin-top: 32px;
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  ${mediaWidth.xl} {
    margin-top: 64px;
  }
`;

const CardTitle = styled.div`
  color: ${Color.SECONDARY};
  ${Font.HEADLINE};
  ${FontWeight.MEDIUM};
  font-size: 16px;
  line-height: 18px;
  text-transform: uppercase;
`;

const CardDescription = styled.div`
  margin-top: 8px;
  
  color: ${Color.TEXT_PRIMARY};
  opacity: .64;
  font-size: 14px;
  line-height: 18px;
`;

const CardBottom = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CardDigit = styled.div`
  color: ${Color.TEXT_PRIMARY};

  ${Font.HEADLINE};
  font-size: 24px;
  line-height: 27px;
`;

const CardArrow = styled.div`
  width: 54px;
  height: 10px;
  background-image: url("${ArrowBlueIcn}");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 166px;
  
  padding: 24px 16px 16px;
  border: 2px solid #0032A0;
  
  cursor: pointer;
  
  &:not(:last-child) {
    border-bottom: none;
  }

  ${mediaWidth.m} {
    width: 168px;
    height: 222px;
    
    padding: 24px 10px 16px;

    &:not(:last-child) {
      border-bottom: 2px solid #0032A0;
    }
    
    &:nth-child(n+5) {
      border-top: none;
    }
    
    &:nth-child(4n+2), &:nth-child(4n+3), &:nth-child(4n+4) {
      border-left: none;
    }
  }

  ${mediaWidth.l} {
    width: 224px;
    height: 202px;
    
    padding: 24px 16px 16px;
    
    cursor: pointer;
  }

  ${mediaWidth.xl} {
    width: 183px;
    height: 186px;

    padding: 24px 12px 16px;
    
    ${CardTitle} {
      color: ${Color.SECONDARY};
    }
    ${CardDescription} {
      display: none;
    }
    ${CardArrow} {
      display: none;
    }
    ${CardDigit} {
      display: block;
    }

    &:nth-child(n) {
      border-top: 2px solid #0032A0;
    }
    &:nth-child(n+2) {
      border-left: none;
    }
    
    &:hover {
      background-color: ${Color.SECONDARY};
      ${CardTitle} {
        color: #FFF;
      }
      ${CardDescription} {
        display: block;
        color: #FFF;
      }
      ${CardDigit} {
        display: none;
      }
      ${CardArrow} {
        display: block;
        background-image: url("${ArrowWhiteIcn}");
      }
    }
  }
`;

export default Start;
